import React, { useState, useRef } from "react";
import "./sub1.css";
import { Helmet } from "react-helmet";
import emailjs from "@emailjs/browser";
import contactConfig from "../../confi";
export default function ServantAvailability() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    serviceType: "",
    familySize: "",
    preferredStartDate: "",
    address: "",
    specialRequirements: "",
  });
  const form = useRef();
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert(
      "24x7 Servant service request submitted successfully! We will contact you soon.",
    );
    // Reset form
    setFormData({
      name: "",
      email: "",
      phone: "",
      serviceType: "",
      familySize: "",
      preferredStartDate: "",
      address: "",
      specialRequirements: "",
    });
  };
  const sendEmail = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await emailjs.sendForm(
        "service_v4bj4cq",
        "template_a7bino9",
        form.current,
        "EPURM9NpZ87StWlSC",
      );

      alert("✅ Message sent successfully!");
      e.target.reset();
    } catch (error) {
      console.error("FAILED...", error.text);
      alert("❌ Failed to send message. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  const servicesOffered = [
    {
      icon: "👩‍🍳",
      title: "Full-time Live-in Maids",
      description: "For cleaning, washing, dusting, and daily chores",
    },
    {
      icon: "🍽️",
      title: "24x7 Cooks",
      description: "To prepare fresh meals as per family preferences",
    },
    {
      icon: "👶",
      title: "Live-in Babysitters/Nannies",
      description: "For round-the-clock child supervision",
    },
    {
      icon: "❤️",
      title: "Elderly Care Attendants",
      description: "Compassionate caregivers for seniors",
    },
    {
      icon: "🚗",
      title: "Personal Drivers",
      description: "Dependable, disciplined, and safety-focused drivers",
    },
    {
      icon: "🧓",
      title: "Patient Care Attendants",
      description: "Skilled helpers for home-based medical support",
    },
  ];

  const serviceFeatures = [
    "Verified background checks & ID verification",
    "Hygienic, well-mannered, and professional behavior",
    "Live-in staff with comfortable stay arrangements",
    "Language & cultural compatibility for Gujarati families",
    "Flexible replacement options when needed",
    "100% confidentiality and safety assurance",
  ];

  const whyChooseUs = [
    {
      title: "Trusted Agency Reputation",
      description:
        "10+ years of delivering reliable household staff across Gujarat.",
      icon: "🏆",
    },
    {
      title: "Premium Quality Selection",
      description:
        "Only trained, responsible, and disciplined staff are shortlisted.",
      icon: "⭐",
    },
    {
      title: "Customized Staff Matching",
      description:
        "We understand your lifestyle, routine, and specific requirements.",
      icon: "🎯",
    },
    {
      title: "Continuous Support",
      description:
        "We provide monitoring, replacement, and quick response services.",
      icon: "📞",
    },
  ];

  const processSteps = [
    {
      step: "1",
      title: "Share Your Requirement",
      description:
        "Tell us what kind of live-in help you need (maid, cook, nanny, etc.)",
    },
    {
      step: "2",
      title: "Profile Shortlisting",
      description: "We share pre-verified profiles based on your preferences",
    },
    {
      step: "3",
      title: "Interview & Selection",
      description: "Meet and interview shortlisted candidates",
    },
    {
      step: "4",
      title: "Placement & Start",
      description:
        "Once selected, the servant joins your home as per your schedule",
    },
    {
      step: "5",
      title: "Follow-up & Support",
      description:
        "We stay in touch to ensure smooth performance and satisfaction",
    },
  ];

  const testimonials = [
    {
      name: "Mrs. Nidhi Patel",
      location: "Satellite, Ahmedabad",
      rating: "⭐⭐⭐⭐⭐",
      text: "We hired a 24-hour maid from JP Home Services for our home in Ahmedabad. She is honest, hardworking, and treats our family like her own.",
    },
    {
      name: "Mr. Shah",
      location: "Vastrapur, Ahmedabad",
      rating: "⭐⭐⭐⭐⭐",
      text: "Our elderly parents needed round-the-clock support. The live-in caretaker provided by JP Home Services is a blessing — reliable and truly compassionate.",
    },
  ];

  const cities = [
    "Ahmedabad",
    "Surat",
    "Vadodara",
    "Rajkot",
    "Gandhinagar",
    "Anand",
    "Bharuch",
    "Mehsana",
    "Jamnagar",
  ];

  const servantPackages = [
    {
      name: "Single Staff Package",
      price: "₹15,999",
      period: "/month",
      features: [
        "✓ One live-in staff member",
        "✓ Background verified",
        "✓ Basic training provided",
        "✓ 24x7 availability",
        "✓ Regular monitoring",
        "✗ Multiple staff",
        "✗ Specialized skills",
      ],
      popular: false,
    },
    {
      name: "Dual Staff Package",
      price: "₹28,999",
      period: "/month",
      features: [
        "✓ Two live-in staff members",
        "✓ Different skill sets",
        "✓ Background verified",
        "✓ Professional training",
        "✓ 24x7 availability",
        "✓ Regular monitoring",
        "✗ Multiple specialized staff",
      ],
      popular: true,
    },
    {
      name: "Premium Family Package",
      price: "₹45,999",
      period: "/month",
      features: [
        "✓ Multiple staff members",
        "✓ Specialized skills",
        "✓ Background verified",
        "✓ Advanced training",
        "✓ 24x7 availability",
        "✓ Priority replacement",
        "✓ Dedicated support",
      ],
      popular: false,
    },
    {
      name: "Custom Enterprise Package",
      price: "Custom",
      period: "Quote",
      features: [
        "✓ Multiple specialized staff",
        "✓ Custom skill requirements",
        "✓ Premium background checks",
        "✓ Specialized training",
        "✓ 24x7 availability",
        "✓ Dedicated manager",
        "✓ Premium support",
      ],
      popular: false,
    },
  ];
  const handleCall = () => {
    window.open(`tel:${contactConfig.phone}`);
  };

  const handleWhatsApp = () => {
    const phoneNumber = `${contactConfig.phone}`;
    const message = "Hello, I would like to know more about your services.";
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, "_blank");
  };
  return (
    <div className="main-content-wrapper">
      <Helmet>
        <title>
          Hire 24x7 Servant Services in Ahmedabad - JP Home Services
        </title>
        <meta
          name="description"
          content="Looking for 24x7 Servant Services in Ahmedabad? JP Home Services provides live-in and full-time servants, maids, cooks, and domestic helpers — trained, verified, and reliable for your home or office needs."
        />
        <meta
          name="keywords"
          content="24x7 Servant Services Ahmedabad, Full-time Maid Ahmedabad, Live-in Servant Gujarat, 24 Hours Maid Services Ahmedabad, Domestic Help Agency Gujarat, JP Home Services, Home Staff Provider Ahmedabad"
        />
        <meta
          name="robots"
          content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1"
        />
        <link
          rel="canonical"
          href="https://jphomeservice.in/servant-services-in-ahmedabad-24-hours"
        />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="Hire 24x7 Servant Services in Ahmedabad - JP Home Services"
        />
        <meta
          property="og:description"
          content="JP Home Services provides 24 hours servant services in Ahmedabad with trained live-in and full-time domestic helpers for home or office needs. Hire now!"
        />
        <meta
          property="og:image"
          content="https://jphomeservice.in/static/media/cleaning.15c8bff08f494c231949.png"
        />
        <meta
          property="og:url"
          content="https://jphomeservice.in/servant-services-in-ahmedabad-24-hours"
        />
        <meta property="og:site_name" content="JP Home Services" />
        <meta property="og:type" content="website" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@" />
        <meta
          name="twitter:title"
          content="Hire 24x7 Servant Services in Ahmedabad - JP Home Services"
        />
        <meta
          name="twitter:description"
          content="JP Home Services provides 24 hours servant services in Ahmedabad with trained live-in and full-time domestic helpers for home or office needs. Hire now!"
        />
        <meta
          name="twitter:image"
          content="https://jphomeservice.in/static/media/cleaning.15c8bff08f494c231949.png"
        />

        {/* JSON-LD Structured Data */}
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "LocalBusiness",
              "name": "24x7 Servant Services in Ahmedabad",
              "image": "https://jphomeservice.in/static/media/TRANSPARNT%20LOGO.1a150556bfeacec71cee.png",
              "@id": "",
              "url": "https://jphomeservice.in/servant-services-in-ahmedabad-24-hours",
              "telephone": "+919327365056",
              "priceRange": "₹₹",
              "address": {
                "@type": "PostalAddress",
                "streetAddress": "A-316-317, Swaminarayan Avenue,  Nr. AEC Cross Road, Naranpura",
                "addressLocality": "Ahmedabad, Gujarat",
                "postalCode": "380013",
                "addressCountry": "IN"
              },
              "geo": {
                "@type": "GeoCoordinates",
                "latitude": 23.0542109,
                "longitude": 72.5482134
              },
              "openingHoursSpecification": {
                "@type": "OpeningHoursSpecification",
                "dayOfWeek": [
                  "Monday",
                  "Tuesday",
                  "Wednesday",
                  "Thursday",
                  "Friday",
                  "Saturday",
                  "Sunday"
                ],
                "opens": "00:00",
                "closes": "23:59"
              },
              "sameAs": [
                "https://www.facebook.com/jphomeservice.in/",
                "https://www.instagram.com/jp_home_service/"
              ] 
            }
         `}
        </script>
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "WebPage",
              "@id": "https://jphomeservice.in/servant-services-in-ahmedabad-24-hours#webpage",
              "url": "https://jphomeservice.in/servant-services-in-ahmedabad-24-hours",
              "name": "Hire 24x7 Servant Services in Ahmedabad - JP Home Services",
              "description": "JP Home Services provides 24 hours servant services in Ahmedabad with trained live-in and full-time domestic helpers for home or office needs. Hire now!",
              "inLanguage": "en-IN",
              "isPartOf": {
                "@type": "WebSite",
                "@id": "https://jphomeservice.in/#website",
                "name": "JP Home Services",
                "url": "https://jphomeservice.in/"
              },
              "publisher": {
                "@type": "Organization",
                "@id": "https://jphomeservice.in/#organization",
                "name": "JP Home Services",
                "url": "https://jphomeservice.in/"
              }
            }
          `}
        </script>
      </Helmet>

      <div className="servant-availability-container">
        {/* Hero Section */}
        <section className="servant-hero-section">
          <div className="container">
            <div className="servant-hero-content">
              <h1>
                24x7 Servant Availability Services in Ahmedabad, Surat & Across
                Gujarat
              </h1>
              <p className="hero-subtitle">
                <strong>
                  Reliable, Verified & Dedicated Domestic Help Round-the-Clock
                </strong>
              </p>
              <p className="hero-description">
                Managing a home that runs smoothly day and night requires
                trusted support. At JP Home Services, we understand that some
                families need 24x7 live-in domestic staff — professionals who
                can handle household responsibilities with care, dedication, and
                trust.
              </p>
              <p className="hero-description">
                Our 24x7 servant availability services in Ahmedabad, Surat, and
                major cities of Gujarat are designed for families who seek
                comfort, security, and consistent assistance — whether it's for
                daily chores, childcare, elderly care, cooking, or household
                management.
              </p>
              <div className="hero-stats">
                <div className="stat-item">
                  <span className="stat-number">10+</span>
                  <p className="stat-label">Years Experience</p>
                </div>
                <div className="stat-item">
                  <span className="stat-number">1000+</span>
                  <p className="stat-label">Families Served</p>
                </div>
                <div className="stat-item">
                  <span className="stat-number">24/7</span>
                  <p className="stat-label">Support</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Floating Contact Icons */}
        <div className="floating-contact-icons">
          <div className="contact-icon whatsapp-icon" onClick={handleWhatsApp}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893c0-3.18-1.24-6.169-3.495-8.424" />
            </svg>
          </div>
          <div className="contact-icon call-icon" onClick={handleCall}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
              <path d="M20 10.999h2C22 5.869 18.127 2 12.99 2v2C17.052 4 20 6.943 20 10.999z" />
              <path d="M13 8c2.103 0 3 .897 3 3h2c0-3.225-1.775-5-5-5v2zm3.422 5.443a1.001 1.001 0 00-1.391.043l-2.393 2.461c-.576-.11-1.734-.471-2.926-1.66-1.192-1.193-1.553-2.354-1.66-2.926l2.459-2.394a1 1 0 00.043-1.391L6.859 3.513a1 1 0 00-1.391-.087l-2.17 1.861a1 1 0 00-.29.649c-.015.25-.301 6.172 4.291 10.766C11.305 20.707 16.323 21 17.705 21c.202 0 .326-.006.359-.008a.992.992 0 00.648-.291l1.86-2.171a1 1 0 00-.086-1.391l-4.064-3.696z" />
            </svg>
          </div>
        </div>

        {/* Services Offered Section */}
        <section className="services-offered-section">
          <div className="container">
            <div className="section-header1">
              <h2> What We Offer</h2>
              <p>
                We provide trained and background-verified live-in domestic
                staff for all major household needs. Each staff member is
                screened, trained, and personally verified by our HR team before
                placement.
              </p>
            </div>

            <div className="services-grid">
              {servicesOffered.map((service, index) => (
                <div key={index} className="service-card">
                  <div className="service-icon">{service.icon}</div>
                  <h3>{service.title}</h3>
                  <p>{service.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Features Section */}
        <section className="features-section">
          <div className="container">
            <div className="section-header">
              <h2>Features of Our 24x7 Servant Availability</h2>
            </div>
            <div className="features-list">
              {serviceFeatures.map((feature, index) => (
                <div key={index} className="feature-item">
                  <span className="check-icon">✓</span>
                  <span>{feature}</span>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Pricing Packages Section */}
        {/* <section className="pricing-packages-section">
          <div className="container">
            <div className="section-header1">
              <h2>Service Packages</h2>
              <p>Comprehensive 24x7 live-in servant packages for different family needs</p>
            </div>

            <div className="packages-grid">
              {servantPackages.map((pkg, index) => (
                <div key={index} className={`package-card ${pkg.popular ? 'popular' : ''}`}>
                  {pkg.popular && <div className="popular-badge">Most Popular</div>}
                  <h3>{pkg.name}</h3>
                  <div className="package-price">
                    {pkg.price}<span>{pkg.period}</span>
                  </div>
                  <ul className="package-features">
                    {pkg.features.map((feature, idx) => (
                      <li key={idx} className={feature.startsWith('✗') ? 'not-included' : ''}>
                        {feature}
                      </li>
                    ))}
                  </ul>
                  <button className="package-btn">
                    {pkg.price === 'Custom' ? 'Get Quote' : 'Select Package'}
                  </button>
                </div>
              ))}
            </div>
          </div>
        </section> */}

        {/* Why Choose Us Section */}
        <section className="why-choose-section">
          <div className="container">
            <div className="section-header">
              <h2>Why Choose 24x7 Servants from JP Home Services?</h2>
            </div>

            <div className="features-grid">
              {whyChooseUs.map((feature, index) => (
                <div key={index} className="feature-card">
                  <div className="feature-icon1">{feature.icon}</div>
                  <h3>{feature.title}</h3>
                  <p>{feature.description}</p>
                </div>
              ))}
            </div>

            <div className="additional-benefits">
              <div className="benefit-item">
                <span className="check-icon">✓</span>
                <span>
                  Complete Peace of Mind – With JP Home Services, your home runs
                  smoothly — day and night.
                </span>
              </div>
            </div>
          </div>
        </section>

        {/* How It Works Section */}
        <section className="process-section">
          <div className="container">
            <div className="section-header">
              <h2>How Our 24x7 Service Works</h2>
            </div>

            <div className="process-steps">
              {processSteps.map((step, index) => (
                <div key={index} className="process-step">
                  <div className="step-number">{step.step}</div>
                  <div className="step-content">
                    <h3>{step.title}</h3>
                    <p>{step.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Booking Form Section */}
        <section className="booking-section">
          <div className="container">
            <div className="booking-content">
              <div className="booking-info">
                <h2>Request 24x7 Servant Service</h2>
                <p>
                  Fill out the form and we'll help you find the perfect live-in
                  domestic staff for your home.
                </p>

                <div className="service-highlights">
                  <div className="highlight-item">
                    <span className="highlight-icon">✅</span>
                    <span>Background verified and ID checked</span>
                  </div>
                  <div className="highlight-item">
                    <span className="highlight-icon">✅</span>
                    <span>Professional and well-mannered staff</span>
                  </div>
                  <div className="highlight-item">
                    <span className="highlight-icon">✅</span>
                    <span>Live-in arrangements handled</span>
                  </div>
                  <div className="highlight-item">
                    <span className="highlight-icon">✅</span>
                    <span>Flexible replacement options</span>
                  </div>
                </div>

                <div className="contact-info">
                  <h3>Need Immediate Assistance?</h3>
                  <p>
                    Call us: <strong>{contactConfig.phone}</strong>
                  </p>
                  <p>
                    Email: <strong>{contactConfig.email}</strong>
                  </p>
                </div>
              </div>

              <div className="booking-form-container">
                <form className="contact-form" ref={form} onSubmit={sendEmail}>
                  <div className="form-group123">
                    <h3>Request 24X7 Service</h3>
                  </div>
                  {/* <div className="form-group">
                      <label htmlFor="location">Maid in Ahmedabad</label>
                    </div> */}

                  <div className="form-group">
                    <input
                      type="text"
                      id="name"
                      name="name"
                      placeholder="Your Name*"
                      required
                    />
                  </div>

                  <div className="form-group">
                    <input
                      type="email"
                      id="email"
                      name="emailid"
                      placeholder="Email Address*"
                      required
                    />
                  </div>

                  <div className="form-group">
                    <input
                      type="tel"
                      id="phone"
                      name="contactno"
                      placeholder="Phone Number*"
                      required
                    />
                  </div>

                  <div className="form-row">
                    <div className="form-group">
                      <select id="category" required name="ServiceRequired">
                        <option value="">Choose a category</option>
                        <option value="House Maid">House Maid</option>
                        <option value="Baby Sitting">Baby Sitting</option>
                        <option value="Elderly Care">Elderly Care</option>
                        <option value="Patient Care">Patient Care</option>
                        <option value="Cook">Cook</option>
                        <option value="Driver">Driver</option>
                        <option value="Full Time Servant">24x7 Servant</option>
                        <option value="Office Boy">Office Boy</option>
                        <option value="Pet Care">Pet Care</option>
                      </select>
                    </div>
                  </div>

                  {/* <div className="form-group">
                      <textarea
                        id="message"
                        placeholder="Your Message*"
                        rows="5"
                        name="user_message"
                        required
                      ></textarea>
                    </div> */}

                  <button
                    type="submit"
                    className="submit-btn1"
                    disabled={loading}
                    onClick={() => {
                      return window.gtag_report_conversion
                        ? window.gtag_report_conversion(
                            "https://jphomeservice.in/",
                          )
                        : true;
                    }}
                  >
                    {loading ? "Sending..." : "Send Message"}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </section>

        {/* Testimonials Section */}
        <section className="testimonials-section">
          <div className="container2">
            <h2>Sample Customer Testimonials</h2>
            <div className="testimonials-grid">
              {testimonials.map((testimonial, index) => (
                <div key={index} className="testimonial-card">
                  <div className="testimonial-rating">{testimonial.rating}</div>
                  <p className="testimonial-text">"{testimonial.text}"</p>
                  <div className="testimonial-author">
                    <strong>{testimonial.name}</strong>
                    <span>{testimonial.location}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Service Coverage Section */}
        <section className="coverage-section">
          <div className="container">
            <div className="section-header1">
              <h2>Available in Major Cities of Gujarat</h2>
              <p>
                Wherever you are in Gujarat, JP Home Services ensures a
                dependable domestic staff solution, 24x7.
              </p>
            </div>

            <div className="cities-grid">
              {cities.map((city, index) => (
                <div key={index} className="city-item">
                  {city}
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}
